(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2455],{

/***/ 58064:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sea_cruise/[id]",
      function () {
        return __webpack_require__(36447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Accordion/accordion.module.sass
var accordion_module = __webpack_require__(38264);
var accordion_module_default = /*#__PURE__*/__webpack_require__.n(accordion_module);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.jsx




var Accordion = function(param) {
    var key = param.key, children = param.children, title = param.title, isOpen = param.isOpen, onCloseExModal = param.onCloseExModal, actionOnClick = param.actionOnClick;
    var ref = (0,react.useState)(isOpen), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (accordion_module_default()).accordion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "accordion-item",
            itemScope: true,
            itemProp: "mainEntity",
            itemType: "https://schema.org/Question",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (accordion_module_default()).accordionTitle,
                    onClick: function() {
                        setIsActive(!isActive);
                        if (onCloseExModal) {
                            onCloseExModal();
                        }
                        if (actionOnClick) {
                            actionOnClick();
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (accordion_module_default()).innerTitle,
                            itemProp: "name",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isActive ? (accordion_module_default()).open : (accordion_module_default()).close
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,classcat/* default */.Z)([
                        (accordion_module_default()).accordionContent,
                        isActive && (accordion_module_default()).accordionContentActive, 
                    ]),
                    itemScope: true,
                    itemProp: "acceptedAnswer",
                    itemType: "https://schema.org/Answer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        itemProp: "text",
                        children: children
                    })
                })
            ]
        })
    }, key);
};

;// CONCATENATED MODULE: ./components/Accordion/index.js



/***/ }),

/***/ 21110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Avatar/avatar.module.sass
var avatar_module = __webpack_require__(16886);
var avatar_module_default = /*#__PURE__*/__webpack_require__.n(avatar_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/Avatar/Avatar.jsx








// import avatar from '../../public/icons/avatar.svg';
var Avatar = function(_param) /*#__PURE__*/ {
    var name = _param.name, userPick = _param.userPick, urlBF = _param.urlBF, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "userPick",
        "urlBF"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (avatar_module_default()).avatar
    }, props), {
        children: !name ? // <img className={styles.avatarImg} src={userPick || avatar} alt={name} />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarImg,
            children: userPick || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: urlBF === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatarBf",
                    width: 40,
                    height: 40
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: "common/avatar",
                    width: 40,
                    height: 40
                })
            })
        }) : // <img
        //   className={styles.avatarImg}
        //   src={ userPick || <AvatarImg />}
        //   alt={name}
        // />
        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (avatar_module_default()).avatarName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                variant: "linkAsButtonPrimarySm",
                transform: "uppercase",
                children: name
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Avatar/index.js



/***/ }),

/***/ 63145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ Collapsed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(59166);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/Collapsed/Collapsed.jsx









/**
 * Компонент для скрытия контента
 * Переписать на нормальный компонент
 */ var Collapsed = function(_param) {
    var items = _param.items, isOpen = _param.isOpen, shorter = _param.shorter, isResult = _param.isResult, isCruis = _param.isCruis, isSeo = _param.isSeo, seo = _param.seo, isPickCaute = _param.isPickCaute, onCloseExModal = _param.onCloseExModal, onClickAction = _param.onClickAction, targets = _param.targets, props = (0,_object_without_properties/* default */.Z)(_param, [
        "items",
        "isOpen",
        "shorter",
        "isResult",
        "isCruis",
        "isSeo",
        "seo",
        "isPickCaute",
        "onCloseExModal",
        "onClickAction",
        "targets"
    ]);
    var ref;
    var ref1 = (0,react.useState)(3), count = ref1[0], setCount = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: seo.map(function(param) {
                    var title = param.title, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        isOpen: isOpen,
                        title: title
                    }, props), {
                        children: description
                    }));
                })
            }),
            isResult ? items === null || items === void 0 ? void 0 : items.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: i.title
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(i.body.text)
                    })
                }), i.title);
            }).slice(0, shorter ? count : items.length) : (ref2 = (ref = items === null || items === void 0 ? void 0 : items.slice(0, shorter ? count : items.length)) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isOpen: isOpen,
                    title: isSeo ? i === null || i === void 0 ? void 0 : i.caption : i === null || i === void 0 ? void 0 : i.title,
                    onCloseExModal: onCloseExModal,
                    actionOnClick: function() {
                        if (i.target) {
                            (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)([
                                i.target
                            ]);
                        }
                    }
                }, props), {
                    children: !isCruis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        content: "".concat(!isPickCaute ? i.body : i === null || i === void 0 ? void 0 : i.desc)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: i.body
                    })
                }), i === null || i === void 0 ? void 0 : i.title);
            })) !== null && ref2 !== void 0 ? ref2 : [].slice(0, shorter ? count : items.length),
            shorter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: count < (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setCount(count + 3);
                        (0,YaAndGaHelper/* YaAndGaCruisePage */.uX)(onClickAction);
                    },
                    children: "Загрузить ещё вопросы"
                })
            })
        ]
    });
};
Collapsed.defaultProps = {
    isOpen: false,
    shorter: false
};

;// CONCATENATED MODULE: ./components/Collapsed/index.js



/***/ }),

/***/ 26167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* reexport */ Comment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pure-react-carousel/dist/index.es.js
var index_es = __webpack_require__(28777);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/simple-react-lightbox/dist/index.es.js
var dist_index_es = __webpack_require__(34930);
// EXTERNAL MODULE: ./components/Comment/comment.module.sass
var comment_module = __webpack_require__(63643);
var comment_module_default = /*#__PURE__*/__webpack_require__.n(comment_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Avatar/index.js + 1 modules
var Avatar = __webpack_require__(21110);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
;// CONCATENATED MODULE: ./components/Comment/Comment.jsx













var options = {
    buttons: {
        showThumbnailsButton: false,
        showAutoplayButton: false,
        showFullscreenButton: true
    },
    thumbnails: {
        showThumbnails: false
    }
};
var Comment = function(_param) {
    var key = _param.key, inicials = _param.inicials, name = _param.name, date = _param.date, children = _param.children, liketext = _param.liketext, disliketext = _param.disliketext, reviewPhoto = _param.reviewPhoto, userPick = _param.userPick, ship = _param.ship, link = _param.link, stars = _param.stars, starShip = _param.starShip, isMobile = _param.isMobile, isModal = _param.isModal, props = (0,_object_without_properties/* default */.Z)(_param, [
        "key",
        "inicials",
        "name",
        "date",
        "children",
        "liketext",
        "disliketext",
        "reviewPhoto",
        "userPick",
        "ship",
        "link",
        "stars",
        "starShip",
        "isMobile",
        "isModal"
    ]);
    var ref = (0,react.useState)(false), showExcDescription = ref[0], setShowExcDescription = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (comment_module_default()).wrapper
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (comment_module_default()).allInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (comment_module_default()).info,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                className: (comment_module_default()).avatar,
                                name: inicials,
                                userPick: userPick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (comment_module_default()).user,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        children: date
                                    })
                                ]
                            })
                        ]
                    }),
                    !isModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (comment_module_default()).rating,
                        children: ship && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (comment_module_default()).link,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    href: "/ships/".concat(link),
                                    variant: "reviewHref",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (comment_module_default()).star,
                                        children: [
                                            "".concat(ship, " ").concat(starShip > 0 ? "".concat(starShip) : ""),
                                            starShip > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/starBlue.svg",
                                                className: (comment_module_default()).star,
                                                alt: "звезда"
                                            })
                                        ]
                                    })
                                }),
                                " "
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classcat/* default */.Z)([
                    showExcDescription ? [] : [
                        (comment_module_default()).excClipper
                    ]
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                    content: "".concat(children)
                })
            }, key),
            isMobile ? children.length > 100 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (comment_module_default()).buttonClipper,
                children: !showExcDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Читать далее"
                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Свернуть отзыв"
                }, key)
            }) : children.length > 300 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (comment_module_default()).buttonClipper,
                children: !showExcDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Читать далее"
                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: function() {
                        setShowExcDescription(!showExcDescription);
                    },
                    view: "reviewsButton",
                    children: "Свернуть отзыв"
                }, key)
            }),
            reviewPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* SRLWrapper */.Iv, {
                    options: options,
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CarouselProvider */.sj, {
                            totalSlides: reviewPhoto && reviewPhoto.length,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (comment_module_default()).imgAll,
                                children: [
                                    reviewPhoto.map(function(i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (comment_module_default()).img,
                                            src: "/images/reviews/".concat(i),
                                            alt: "фото туристов"
                                        });
                                    }),
                                    " "
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/Comment/index.js



/***/ }),

/***/ 63002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ Dots; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/Dots/dots.module.sass
var dots_module = __webpack_require__(55828);
var dots_module_default = /*#__PURE__*/__webpack_require__.n(dots_module);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
;// CONCATENATED MODULE: ./components/Dots/Dots.jsx






var Dots = function(param) {
    var view = param.view, count = param.count, active = param.active, onSelect = param.onSelect, spaceBetween = param.spaceBetween, topGap = param.topGap;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classcat/* default */.Z)([
            (dots_module_default()).dots,
            (dots_module_default())[view]
        ]),
        style: {
            paddingTop: "".concat(topGap, " px")
        },
        children: isClient/* isClient */.C && new Array(count).fill(0).map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Select",
                style: {
                    margin: "0 ".concat(spaceBetween, "px")
                },
                onClick: function() {
                    if (onSelect) onSelect(index);
                },
                className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (dots_module_default()).active, active === index))
            }, index);
        })
    });
};
Dots.defaultProps = {
    view: "regularDots",
    spaceBetween: 4,
    topGap: 16,
    onSelect: null
};

;// CONCATENATED MODULE: ./components/Dots/index.js



/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ PrevArrow; },
/* harmony export */   "Ci": function() { return /* binding */ PrevThumbArrow; },
/* harmony export */   "gV": function() { return /* binding */ NextArrow; },
/* harmony export */   "s6": function() { return /* binding */ NextThumbArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99407);
/* harmony import */ var _arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85708);
/* harmony import */ var _SpriteSVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2708);






var PrevArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29
            })
        })
    });
};
var NextArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-arrow",
                width: 16,
                height: 29,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var PrevThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonPrev)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};
var NextThumbArrow = function(param) {
    var enabled = param.enabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButton),
            (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().emblaButtonNext)
        ]),
        onClick: onClick,
        disabled: !enabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
            className: (_arrows_module_sass__WEBPACK_IMPORTED_MODULE_5___default().lg),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SpriteSVG__WEBPACK_IMPORTED_MODULE_3__/* .IconSVG */ .u, {
                name: "common/gallery-thumb-arrow",
                width: 9,
                height: 17,
                alt: "К следующему"
            }),
            title: "К следующему"
        })
    });
};


/***/ }),

/***/ 49028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52851);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_image_module_sass__WEBPACK_IMPORTED_MODULE_5__);






var Image = function(_param) /*#__PURE__*/ {
    var src = _param.src, srcSet = _param.srcSet, alt = _param.alt, width = _param.width, height = _param.height, size = _param.size, _media = _param.media, media = _media === void 0 ? "500px" : _media, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "srcSet",
        "alt",
        "width",
        "height",
        "size",
        "media"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        children: [
            srcSet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(srcSet),
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: "".concat(src),
                alt: alt,
                className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default().root),
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default())[size]
                ]),
                width: size ? "100%" : "".concat(width, "px"),
                height: size ? "100%" : "".concat(height, "px")
            }, props))
        ]
    });
};
Image.defaultProps = {
    src: "",
    srcSet: "",
    alt: "",
    width: 300,
    height: 300,
    size: "cover"
};


/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.u; }
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31735);



/***/ }),

/***/ 22334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Reviews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/Comment/index.js + 1 modules
var Comment = __webpack_require__(26167);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./hooks/useLimitList.js
var useLimitList = __webpack_require__(99905);
// EXTERNAL MODULE: ./components/Reviews/reviews.module.sass
var reviews_module = __webpack_require__(69907);
var reviews_module_default = /*#__PURE__*/__webpack_require__.n(reviews_module);
;// CONCATENATED MODULE: ./components/Reviews/Reviews.jsx









var Reviews = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, link = param.link, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, noButton = param.noButton, clipp = param.clipp, setClipp = param.setClipp, isMobile = param.isMobile, isModal = param.isModal, metriks = param.metriks;
    var ref = (0,useLimitList/* useLimitList */.U)({
        count: items.length,
        limit: limit
    }), show = ref.show, isCanShowMore = ref.isCanShowMore, onShowMore = ref.onShowMore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            items.length > 0 && (limit ? items.slice(0, show) : items).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment/* Comment */.s, {
                    userPick: item.user_img && "".concat("https://kruiz.online", "/").concat(item.user_img),
                    name: item.username,
                    date: dayjs_min_default()(item.r_date).format("DD MMMM YYYY"),
                    link: item.url,
                    ship: item.t_title,
                    stars: item.raiting_company,
                    starShip: item.raiting_ship,
                    reviewPhoto: item.fotos,
                    clipp: clipp,
                    setClipp: setClipp,
                    isMobile: isMobile,
                    isModal: isModal,
                    children: item.review
                }, index);
            }),
            !noButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                condition: !link,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                        children: isCanShowMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "lg",
                            onClick: function() {
                                onShowMore();
                                window.ym(35441960, "reachGoal", metriks);
                            // YaAndGaCruisePage(onClickAction);
                            // YaAndGaShipPage(onActionClick);
                            },
                            fullWidth: true,
                            children: "Загрузить ещё отзывы"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (reviews_module_default()).infoWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (reviews_module_default()).info,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                    className: (reviews_module_default()).button,
                                    href: link,
                                    variant: "linkAsbutton2",
                                    onClick: function() {
                                        window.ym(35441960, "reachGoal", metriks);
                                    },
                                    children: "Загрузить ещё отзывы"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Reviews/index.js



/***/ }),

/***/ 7824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ TravelTime; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/TravelTime/traveltime.module.sass
var traveltime_module = __webpack_require__(42517);
var traveltime_module_default = /*#__PURE__*/__webpack_require__.n(traveltime_module);
;// CONCATENATED MODULE: ./components/TravelTime/TravelTime.jsx





// import { IconSVG } from '../SpriteSVG';
// import { Icon } from '../Icon';
// import { YaAndGaCruisePage } from '../../lib/YaAndGaHelper';
var TravelTime = function(param) {
    var start = param.start, end = param.end, days = param.days, nights = param.nights, className = param.className, size = param.size, startTime = param.startTime, endTime = param.endTime, // url,
    // ownerId,
    isMoscow = param.isMoscow;
    var formatDays = "".concat(days, " дн.");
    var formatNights = "".concat(nights !== null && nights !== void 0 ? nights : days - 1, " нч.");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classcat/* default */.Z)([
            (traveltime_module_default()).wrapper,
            (traveltime_module_default())[size],
            (0,_define_property/* default */.Z)({}, className, !!className), 
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (traveltime_module_default()).dates,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: start
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: startTime && startTime !== "00:00" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (traveltime_module_default()).time,
                                    children: [
                                        startTime,
                                        !isMoscow && " (местное)"
                                    ]
                                })
                            })
                        ]
                    }),
                    "-",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "".concat(end)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: endTime && endTime !== "00:00" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (traveltime_module_default()).time,
                                    children: [
                                        endTime,
                                        !isMoscow && " (местное)"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (traveltime_module_default()).days,
                children: [
                    days && formatDays,
                    " / ",
                    (nights || days) && formatNights
                ]
            })
        ]
    });
};
TravelTime.defaultProps = {
    className: null,
    nights: null,
    size: "default"
};

;// CONCATENATED MODULE: ./components/TravelTime/index.js



/***/ }),

/***/ 21471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useEmblaSlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25585);
/* harmony import */ var embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22074);




var useEmblaSlider = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        loop: false,
        skipSnaps: false
    }, isAutoplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var autoplay = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        delay: 5000
    }, function(emblaRoot) {
        return emblaRoot.parentElement;
    }));
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), current = ref[0], setCurrent = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(options, isAutoplay ? [
        autoplay.current
    ] : undefined), 2), ref2 = ref1[0], embla = ref1[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), prevBtnEnabled = ref3[0], setPrevBtnEnabled = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), nextBtnEnabled = ref4[0], setNextBtnEnabled = ref4[1];
    var scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollNext();
    }, [
        embla
    ]);
    var onSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!embla) return;
        setCurrent(embla.selectedScrollSnap());
        setPrevBtnEnabled(embla.canScrollPrev());
        setNextBtnEnabled(embla.canScrollNext());
    }, [
        embla,
        current
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!embla) return;
        onSelect();
        embla.on("select", onSelect);
    }, [
        embla,
        onSelect
    ]);
    var onSelectSlide = function(index) {
        embla.scrollTo(index);
    };
    return {
        ref: ref2,
        current: current,
        onSelectSlide: onSelectSlide,
        scrollPrev: scrollPrev,
        scrollNext: scrollNext,
        prevBtnEnabled: prevBtnEnabled,
        nextBtnEnabled: nextBtnEnabled
    };
};


/***/ }),

/***/ 11711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHiddenWithCookie; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);



var useHiddenWithCookie = function(func) {
    var getCookie = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)();
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
    var timeEnd = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(getCookie === null || getCookie === void 0 ? void 0 : getCookie.timeToOpenBanner);
    var timeToOpen = timeEnd <= currentDate;
    // eslint-disable-next-line consistent-return
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (timeToOpen) {
            func();
        }
    }, []);
};


/***/ }),

/***/ 99905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useLimitList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLimitList = function(param) {
    var count = param.count, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(limit), show = ref[0], setShow = ref[1];
    var onShowMore = function() {
        setShow(show + limit);
    };
    return {
        show: show,
        onShowMore: onShowMore,
        isCanShowMore: count > limit && count > show
    };
};


/***/ }),

/***/ 13866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ sendVKPixelEvent; }
/* harmony export */ });
var sendVKPixelEvent = function(goal, params) {
    if ( false || !window._tmr) return;
    var product_id = params.product_id, value = params.value;
    window._tmr.push({
        type: "reachGoal",
        id: 3320999,
        value: value !== null && value !== void 0 ? value : 0,
        goal: goal,
        params: {
            product_id: product_id
        }
    });
};


/***/ }),

/***/ 36447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SeaCruizPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next-useragent/dist/next-useragent.js
var next_useragent = __webpack_require__(28010);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/lvovich/lib/index.js
var lib = __webpack_require__(80297);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js
var esm = __webpack_require__(63108);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./components/Layout/index.js + 6 modules
var Layout = __webpack_require__(82913);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./components/Features/index.js + 1 modules
var Features = __webpack_require__(15944);
// EXTERNAL MODULE: ./components/Badge/index.js + 1 modules
var Badge = __webpack_require__(92558);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./components/Motivator/motivator.module.sass
var motivator_module = __webpack_require__(9920);
var motivator_module_default = /*#__PURE__*/__webpack_require__.n(motivator_module);
;// CONCATENATED MODULE: ./components/Motivator/Motivator.jsx




var Motivator = function(param) {
    var children = param.children, emoji = param.emoji, textcolor = param.textcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (motivator_module_default()).border,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (motivator_module_default()).emojiBlock,
                children: emoji
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    variant: "text-4",
                    colorText: textcolor,
                    children: children
                })
            })
        ]
    });
};
Motivator.defaultProps = {
    textcolor: "orange"
};

;// CONCATENATED MODULE: ./components/Motivator/index.js


// EXTERNAL MODULE: ./components/Collapsed/index.js + 1 modules
var Collapsed = __webpack_require__(63145);
// EXTERNAL MODULE: ./utils/declOfNum.js
var declOfNum = __webpack_require__(5547);
// EXTERNAL MODULE: ./styles/cruizPage.module.sass
var cruizPage_module = __webpack_require__(18201);
var cruizPage_module_default = /*#__PURE__*/__webpack_require__.n(cruizPage_module);
;// CONCATENATED MODULE: ./resources/faqitemsea.jsx



var faqItems = [
    {
        title: "Что включено и не включено в стоимость круиза",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "В стоимость обычно включается: размещение в каюте выбранной категории, питание на борту — завтрак, обед, ланч, ужин, поздний ужин, все развлекательные программы на борту, пользование спортивным оборудованием, бассейнами, а также плавсредствами для посадки и высадки в портах, где корабль не причаливает к пристани. Дополнительно оплачиваются портовые и топливные сборы (как правило, при бронировании), пакеты напитков, услуги массажа, стирка и глажка одежды, процедуры в спа-центрах и т.п.), экскурсии и чаевые. При оформлении круизного тура всегда следует уделять особое внимание дополнительным услугам, которые чаще всего не входят в стоимость основной программы: авиабилетам, медицинской страховке, трансферам и визам."
        })
    },
    {
        title: " На какую дату бронировать перелет в город отправления круиза?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "Рекомендуем выбирать рейс, прилетающий за день до начала круиза: так вы сможете избежать опоздания на круиз в случае задержки рейса. А также нужно потратить время на дорогу от аэропорта до морского порта. Корабль не будет дожидаться опоздавших. А догонять лайнер придется в других городах, потратив на это много нервов, времени и средств."
        })
    },
    {
        title: "Какие документы нужны для круиза и во время круиза?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cruizPage_module_default()).listFull,
            children: [
                "Для круиза Вам необходимо иметь документы на все забронированные и оплаченные услуги. Это: ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "авиабилет,"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "ваучер на круиз с указанием корабля, даты начала и даты окончания маршрута, номера каюты и описанием маршрута,"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "медицинский страховой полис,"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "ваучер на трансфер,"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "виза (при необходимости),"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "ваучер на проживание до и (или) после круиза."
                })
            ]
        })
    },
    {
        title: "Что взять с собой?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cruizPage_module_default()).listFull,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Фотоаппарат"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Солнечные очки"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Крем от солнечных лучей"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Удобная обувь для экскурсий"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Сланцы (для пляжа/ бассейна)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Зимняя одежда (для северных кризов)"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Легкая теплая одежда"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Плащ / зонт"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Одежда для ужина в стиле Casual (футболки, джинсы, шорты, рубашки с воротником, и т.д.)"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Вечерняя одежда (для ужинов с капитаном / коктейльных вечеринок)"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: " Купальник"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Туалетные принадлежности"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Аптечка"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Банковские карты"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Наличные деньги"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Заграничный паспорт"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Водительские права международного образца (если Вы планируете брать машину на прокат)"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Билеты\\ваучеры\\путевки"
                })
            ]
        })
    },
    {
        title: "Посадка на лайнер",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cruizPage_module_default()).listFull,
            children: [
                "По прибытии в порт посадки следуйте указателям с надписью нужного корабля. Регистрация на корабль, обычно, начинается за 3-4 часа и заканчивается за 1,5-2 часа до отплытия. До посадки на корабль туристам нужно:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "наклеить на багаж специальные бирки, которые выдаются при регистрации на лайнер. На бирках нужно указать латинскими буквами имя, фамилию, название корабля, номер каюты, дату и порт отправления;"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "сдать багаж с наклеенными бирками носильщикам, которые доставят его к дверям каюты ( в течение часа после отплытия);"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "подойти к стойке регистрации и предъявить паспорт и билет на круиз;"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "после проверки документов пассажирам выдается магнитная карта, которая в дальнейшем используется как ключ от каюты, пропуск на корабль и карта для оплаты услуг."
                })
            ]
        })
    },
    {
        title: " Опоздание на регистрацию",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "Если туристы опоздали на регистрацию на лайнер, то они должны в срочном порядке информировать о данном инциденте генерального представителя или свое агентство, указав, в каком из портов по маршруту они присоединятся к круизу. Все расходы, связанные с транспортировкой опоздавших пассажиров берут на себя сами опоздавшие пассажиры. Если турист не информирует об опоздании – его каюта будет аннулирована, штраф по аннуляции составит 100%"
        })
    },
    {
        title: "Как производятся расчеты на борту?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "На борту всех кораблей действует система безналичного расчета: для оплаты всех расходов туристы используют круизную карту. По окончании круиза потраченную сумму списывают с кредитной карты или с депозита, которые привязываются к круизной карте в начале путешествия."
        })
    },
    {
        title: "Стиль одежды на борту",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "В большинстве случаев вполне подходящей является комфортная повседневная одежда. Более нарядный вариант приветствуется при посещении ресторанов. На гала-ужины мужчинам рекомендуется приходить в костюме и галстуке, а женщинам – в вечернем платье. В случае необходимости костюм или смокинг можно взять напрокат. В ресторанах не приветствуются футболки, рваные джинсы, шорты, спортивная одежда и т.п. Для посещения береговых экскурсий подойдет удобная одежда и обувь. Для посещения бассейнов, джакузи, аквапарков не стоит забывать об одежде для плавания."
        })
    },
    {
        title: "Организация питания",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cruizPage_module_default()).listFull,
            children: [
                "На круизных лайнерах в большинстве случаев питание представляет собой полный пансион и входит в стоимость тура. Типичное расписание питания на борту выглядит примерно следующим образом:",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "06:00 горячий чай и кофе на палубе для любителей раннего подъема."
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Завтрак. Обычно в ресторане предлагают различные варианты типичных для завтрака блюд. В качестве альтернативы, можно позавтракать на \xabшведском столе\xbb или в кафе на открытом воздухе."
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Обед в основном ресторане, в ресторане со \xabшведским столом\xbb, либо в кафе."
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "16:00 чай с бутербродами и пирожными."
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Ужин – основное событие вечера, и обычно, за исключением первого вечера после посадки, он предполагает более формальный стиль одежды."
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Полночный буфет"
                }),
                "На многих современных лайнерах, помимо основного питания предусмотрены круглосуточные кафе, где можно перекусить в любое время. Кроме того на многих кораблях есть альтернативные рестораны, где за дополнительную плату можно забронировать себе столик и насладиться шедеврами кулинарного искусства и великолепным сервисом в романтической атмосфере. Также при желании туристы могут заказать себе при бронировании круиза специальное диетическое питание."
            ]
        })
    },
    {
        title: "Развлечения на борту",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "Спектр развлечений во время круиза весьма широк и разнообразен. Он тщательно разрабатывается с учетом того, что на борту лайнера путешествуют пассажиры разных национальностей и разных вкусов. Туристы всегда смогут найти мероприятие, которое будет им интересно: ежевечернее шоу (концерты, мюзиклы и т.п.), дискотека, концерты живой музыки в разных холлах, конкурсы и соревнования. В течение дня в разных холлах на открытой палубе команда аниматоров организовывает различные активности. На борту многих лайнеров работает казино. Помимо всего, у отдыхающих есть возможность воспользоваться услугами фитнесс-центра: спортзал, беговая дорожка, сауна, джакузи, бассейн и т.д. (набор таких услуг может варьироваться на разных лайнерах). На некоторых лайнерах есть даже каток, стена для занятий скалолазанием, бассейн для серфинга. На современных кораблях оборудованы SPA-центры, в которых предлагают массу оздоровительных процедур (за дополнительную плату). Для детей существует также много развлечений: так, под наблюдением специальной анимационной команды, они могут провести время в группе, соответствующей их возрасту, провести время в детской библиотеке или детской комнате."
        })
    },
    {
        title: "Услуги на борту",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (cruizPage_module_default()).listFull,
            children: [
                "Интернет. Все современные лайнеры предлагают услуги Интернет-кафе на борту. На многих лайнерах оборудовано подключение к Интернету в каюте, а современные корабли предлагают услугу беспроводного Интернета. Эта услуга платная.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Услуги прачечной. Практически на всех лайнерах предлагаются услуги стирки и глажения вещей, а также химчистки. Подробный перечень и прейскурант можно будет найти в каюте.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Медицинские услуги. Практически все лайнеры предлагают квалифицированную медицинскую помощь. На борту каждого корабля есть медцентр, предназначенный для решения экстренных или несложных медицинских проблем. Бортовой врач обычно берет плату за свои услуги. В момент бронирования каюты турист обязан сообщить о любых существенных проблемах со здоровьем, требующих особого медицинского ухода.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Телекоммуникация на борту. Наличие на кораблях спутниковой связи позволяет туристам беспрепятственно делать звонки.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Сейф. Бесплатный сейф есть в некоторых каютах и на стойке регистрации.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        })
    },
    {
        title: "Высадка на берег в портах захода",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cruizPage_module_default()).listFull,
            children: "По прибытии в порт представители местных властей проводят документационную инспекцию лайнера, по окончании которой пассажиров приглашают пройти к трапам. Сначала на берег выходят участники береговых экскурсий, затем – пассажиры, которые выходят самостоятельно. Выход и вход на лайнер происходят по бортовым пластиковым картам, которые необходимо предъявлять для проверки службе безопасности. Пассажиры могут свободно выходить на берег в любое время и аналогичным образом возвращаться на борт лайнера. Но следует помнить, что все пассажиры должны вернуться на борт лайнера не позднее чем за 60 минут до отплытия. Лайнер опоздавших не ждет, и догонять его придется за свой счет. В самом экстренном случае, если туристы все-таки по какой-то причине опоздали, им необходимо связаться с портовым агентом (координаты портового агента всегда указаны в ежедневных программах), который поможет им организовать необходимое размещение и транспортировку."
        })
    }, 
];

// EXTERNAL MODULE: ./components/CruisePageComponents/VendorLink/index.js + 1 modules
var VendorLink = __webpack_require__(74701);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./components/CruisePageComponents/ExcursionProgramm/index.js + 1 modules
var ExcursionProgramm = __webpack_require__(35158);
// EXTERNAL MODULE: ./components/CruisePageComponents/PricePanel/index.js + 2 modules
var PricePanel = __webpack_require__(96705);
// EXTERNAL MODULE: ./utils/scrollToUtil.js
var scrollToUtil = __webpack_require__(17740);
// EXTERNAL MODULE: ./components/Reviews/index.js + 1 modules
var Reviews = __webpack_require__(22334);
// EXTERNAL MODULE: ./lib/StorageManager.js
var StorageManager = __webpack_require__(94701);
// EXTERNAL MODULE: ./components/PickCaute/index.js + 18 modules
var PickCaute = __webpack_require__(16781);
// EXTERNAL MODULE: ./components/CruisePageComponents/CruiseDescription/index.js + 1 modules
var CruiseDescription = __webpack_require__(86905);
// EXTERNAL MODULE: ./components/CruisePageComponents/GenericList/index.js + 1 modules
var GenericList = __webpack_require__(92709);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./components/CruisePageComponents/CancellationAndReturn/cancellationandreturn.module.sass
var cancellationandreturn_module = __webpack_require__(83200);
var cancellationandreturn_module_default = /*#__PURE__*/__webpack_require__.n(cancellationandreturn_module);
;// CONCATENATED MODULE: ./components/CruisePageComponents/CancellationAndReturn/CancellationAndReturn.jsx







var CancellationAndReturn = function(param) {
    var policy_details = param.policy_details, cabin_cancellation = param.cabin_cancellation;
    var ref;
    var ref1;
    var filteredPolicyDetails = (ref1 = policy_details === null || policy_details === void 0 ? void 0 : policy_details.filter(function(i) {
        return i[0] !== "" || i[1] !== "";
    })) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2 = (0,react.useState)(false), isOpenDescription = ref2[0], setIsOpenDescription = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (cancellationandreturn_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                component: "h2",
                variant: "heading-4",
                children: "Правила отмены и возврата"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (cancellationandreturn_module_default()).subdesc,
                children: "Количество дней до круиза - процент удержания от стоимости"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,classcat/* default */.Z)([
                    (cancellationandreturn_module_default()).ReturnDesc,
                    (0,_define_property/* default */.Z)({}, (cancellationandreturn_module_default()).open, isOpenDescription), 
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (cancellationandreturn_module_default()).list,
                        children: Object.values(filteredPolicyDetails).map(function(AllRule, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: AllRule.title !== null && AllRule.title
                                    }),
                                    AllRule.table !== null && AllRule.table.map(function(rule) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: (cancellationandreturn_module_default()).listItem,
                                            children: [
                                                rule[0],
                                                " - ",
                                                rule[1]
                                            ]
                                        }, key);
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                variant: "heading-7",
                                children: cabin_cancellation === null || cabin_cancellation === void 0 ? void 0 : cabin_cancellation.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (cancellationandreturn_module_default()).list,
                                children: (cabin_cancellation === null || cabin_cancellation === void 0 ? void 0 : cabin_cancellation.title) && (cabin_cancellation === null || cabin_cancellation === void 0 ? void 0 : (ref = cabin_cancellation.body) === null || ref === void 0 ? void 0 : ref.map(function(rule, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (cancellationandreturn_module_default()).listItem,
                                        children: rule
                                    }, key);
                                }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                size: "sm",
                onClick: function() {
                    return setIsOpenDescription(!isOpenDescription);
                },
                children: [
                    isOpenDescription ? "Скрыть" : "Все",
                    " правила"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/CruisePageComponents/CancellationAndReturn/index.js


// EXTERNAL MODULE: ./components/CruisePageComponents/MainGallery/index.js + 6 modules
var MainGallery = __webpack_require__(98796);
// EXTERNAL MODULE: ./components/TravelTime/index.js + 1 modules
var TravelTime = __webpack_require__(7824);
// EXTERNAL MODULE: ./lib/yandexDataLayer.js
var yandexDataLayer = __webpack_require__(12406);
// EXTERNAL MODULE: ./components/InfoblockSliders/index.js + 3 modules
var InfoblockSliders = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/BreadCrumbs/index.js + 1 modules
var BreadCrumbs = __webpack_require__(24277);
// EXTERNAL MODULE: ./components/ExcursionGallery/index.js + 1 modules
var ExcursionGallery = __webpack_require__(6287);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./providers/SearchStoreProvider.tsx + 5 modules
var SearchStoreProvider = __webpack_require__(27101);
;// CONCATENATED MODULE: ./utils/inArray.js
var inArray = function(array, ids) {
    return ids.every(function(_id) {
        return array.includes(_id);
    });
};

// EXTERNAL MODULE: ./components/ModalReload/index.js + 1 modules
var ModalReload = __webpack_require__(72581);
// EXTERNAL MODULE: ./hooks/useHiddenWithCookie.js
var useHiddenWithCookie = __webpack_require__(11711);
// EXTERNAL MODULE: ./utils/useFormatDate.js
var useFormatDate = __webpack_require__(14971);
// EXTERNAL MODULE: ./components/ModalShareSocial/index.js + 1 modules
var ModalShareSocial = __webpack_require__(26121);
// EXTERNAL MODULE: ./components/ActualPanel/index.js + 1 modules
var ActualPanel = __webpack_require__(50101);
// EXTERNAL MODULE: ./utils/isBlackFridayCheck.js
var isBlackFridayCheck = __webpack_require__(66373);
// EXTERNAL MODULE: ./lib/sendVKPixelEvent.js
var sendVKPixelEvent = __webpack_require__(13866);
;// CONCATENATED MODULE: ./pages/sea_cruise/[id].jsx



























// import { cityLinks } from '../../resources/cityLinks';



























var BannerTop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9422).then(__webpack_require__.bind(__webpack_require__, 9422)).then(function(mod) {
        return mod.CookieBanner;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9422)
            ];
        }
    }
});
var __N_SSP = true;
function SeaCruizPage(param) {
    var uaString = param.uaString, cookies = param.cookies, _store = param.store, user = _store.user, cruiz = _store.cruiz, places = _store.places, reviews = _store.reviews, position = _store.position, motivatorReady = _store.motivatorReady, motivatorColor = _store.motivatorColor, motivatorEmoji = _store.motivatorEmoji, clientBuy = _store.clientBuy, idCruiz = _store.idCruiz, token = _store.token, schema = _store.schema, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ua = (0,next_useragent/* useUserAgent */.FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var router = (0,next_router.useRouter)();
    var currentLink = router.asPath;
    var options = {
        buttons: {
            showThumbnailsButton: false,
            showAutoplayButton: false,
            showFullscreenButton: false
        },
        thumbnails: {
            showThumbnails: false
        }
    };
    var ref12 = (0,react.useState)(false), cruizeFeaturesIsOpen = ref12[0], setCruizeIsOpen = ref12[1];
    var ref13 = (0,react.useState)(false), cruizeRoutesIsOpen = ref13[0], setCruizeRoutesIsOpen = ref13[1];
    var ref14 = (0,react.useState)(false), showFixedBtn = ref14[0], setShowFixedBtn = ref14[1];
    var ref15 = (0,react.useState)(false), servicesDescIsOpen = ref15[0], setServicesDescIsOpen = ref15[1];
    var ref16 = (0,react.useState)(false), showExcDescription = ref16[0], setShowExcDescription = ref16[1];
    var tmp = cruiz.ship_info, ref17 = tmp === void 0 ? {} : tmp, t_title = ref17.t_title, category_name = ref17.category_name, company = ref17.company, ship_direction = ref17.ship_direction, tmp1 = ref17.// exc_included,
    ship_fotos, ref18 = tmp1 === void 0 ? {} : tmp1, maxi = ref18.maxi, mini = ref18.mini, facilities = ref17.facilities, description = ref17.description, placing_children = ref17.placing_children, _price_includes = ref17.price_includes, price_includes = _price_includes === void 0 ? {} : _price_includes, owner_id = ref17.owner_id, // promotion,
    cabin_cancellation = ref17.cabin_cancellation, url = ref17.url, seat_of_the_ship = ref17.seat_of_the_ship, cauta_count = ref17.cauta_count, construction_date = ref17.construction_date, restoration_date = ref17.restoration_date, tmp2 = cruiz.cruise, ref19 = tmp2 === void 0 ? {} : tmp2, _route_full = ref19.route_full, route_full = _route_full === void 0 ? "" : _route_full, kr_date_start = ref19.kr_date_start, kr_date_end = ref19.kr_date_end, min_price = ref19.min_price, min_price_discounted = ref19.min_price_discounted, kr_days = ref19.kr_days, free_places_left = ref19.free_places_left, ship_id = ref19.ship_id, special_note = ref19.special_note, city_start = ref19.city_start, vendor_link = ref19.vendor_link, return_trip = ref19.return_trip, route_img = ref19.route_img, cruise_id = ref19.cruise_id, tariffs = ref19.tariffs, tmp3 = cruiz.new_cancellation, policy_details = (tmp3 === void 0 ? {} : tmp3).policy_details, discounts = cruiz.discounts, _timetable_excursions = cruiz.timetable_excursions, timetable_excursions = _timetable_excursions === void 0 ? {} : _timetable_excursions;
    var startDate = dayjs_min_default()(kr_date_start).format("DD MMMM YYYY");
    var endDate = dayjs_min_default()(kr_date_end).format("DD MMMM YYYY");
    var shipDetail = {
        restorationDate: restoration_date,
        constructionDate: construction_date,
        cabinCount: cauta_count,
        passengerCount: seat_of_the_ship,
        title: t_title
    };
    var shortStartDate = (0,useFormatDate/* formatDateStart */.yk)(kr_date_start, kr_date_end);
    var shortEndDate = (0,useFormatDate/* formatDateEnd */.fc)(kr_date_end, {
        isCruise: true
    });
    var isAstoria = owner_id === 100022;
    var favoriteData = {
        id: idCruiz,
        title: t_title,
        price: min_price,
        route: route_full,
        imgUrl: maxi === null || maxi === void 0 ? void 0 : (ref = maxi[0]) === null || ref === void 0 ? void 0 : ref.url,
        places: free_places_left,
        category: category_name,
        startDate: kr_date_start,
        endDate: kr_date_end,
        images: route_img,
        special_note: special_note,
        kr_days: kr_days,
        ship_id: ship_id,
        isSea: true
    };
    var cruizDetail = {
        id: idCruiz,
        name: "".concat(t_title, " с ").concat(shortStartDate, " по ").concat(shortEndDate),
        brand: company || "Море",
        category: "".concat(ship_direction === "sea" ? "Море" : "Река", "/").concat(category_name, "/").concat(t_title, "/").concat(route_full),
        list: (cruiz === null || cruiz === void 0 ? void 0 : (ref1 = cruiz.cruise) === null || ref1 === void 0 ? void 0 : ref1.directionName) || "",
        price: min_price,
        quantity: 1
    };
    var timetableExcursions = Object.values(timetable_excursions);
    var elRef = (0,react.useRef)();
    var badgeReviewsRef = (0,react.useRef)();
    var badgeClassRef = (0,react.useRef)();
    var servicesRef = (0,react.useRef)();
    var badgeSaleRef = (0,react.useRef)();
    // const activeCitySlug = Object.keys(cityLinks).find(key =>
    //   route_full.startsWith(cityLinks[key]),
    // );
    var classCategoryReady;
    if (position === 2) {
        motivatorReady += (0,lib/* cityFrom */.R7)(city_start);
    }
    var headerHeight = isMobile ? 124 : 148;
    (0,react.useEffect)(function() {
        var ref, ref1;
        // Яндекс метрика - информация о пользователи и типе страницы
        (0,yandexDataLayer/* yandexUserLayer */.p$)(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id, user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.group, true);
        // YaAndGaCruisePage('isSeaPage');
        // Яндекс метрика - просмотр товара
        (0,yandexDataLayer/* yandexDataLayer */.qu)("detail", cruizDetail);
        (0,sendVKPixelEvent/* sendVKPixelEvent */.c)("viewProduct", {
            product_id: idCruiz,
            value: min_price
        });
        if (isClient/* isClient */.C) {
            var ref2;
            // Добавление в просмотренные
            var viewed = (ref2 = StorageManager/* StorageManager.get */.A.get("viewed")) !== null && ref2 !== void 0 ? ref2 : [];
            var isCurrentViewed = viewed.findIndex(function(i) {
                return i === cruise_id;
            }) !== -1;
            if (!isCurrentViewed) {
                StorageManager/* StorageManager.set */.A.set("viewed", (0,_to_consumable_array/* default */.Z)(viewed).concat([
                    cruise_id
                ]));
            }
        }
        if (isClient/* isClient */.C && isMobile) {
            document.addEventListener("scroll", function() {
                var ref, ref1, ref2, ref3;
                var windowTop = window.pageYOffset;
                var windowBottom = windowTop + window.innerHeight;
                // Параметры первого блока, который предлагает выбрать каюту
                var pickHeight = badgeClassRef === null || badgeClassRef === void 0 ? void 0 : (ref = badgeClassRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
                var pickTop = badgeClassRef === null || badgeClassRef === void 0 ? void 0 : (ref1 = badgeClassRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetTop;
                var pickBottom = pickHeight + pickTop;
                // Параметры блока со списком кают
                var chooseHeight = elRef === null || elRef === void 0 ? void 0 : (ref2 = elRef.current) === null || ref2 === void 0 ? void 0 : ref2.clientHeight;
                var chooseTop = elRef === null || elRef === void 0 ? void 0 : (ref3 = elRef.current) === null || ref3 === void 0 ? void 0 : ref3.offsetTop;
                var chooseBottom = chooseHeight + chooseTop;
                if (pickBottom - 130 - headerHeight > windowTop || chooseTop + 100 < windowBottom && chooseBottom - headerHeight - 80 > windowTop) {
                    setShowFixedBtn(false);
                } else {
                    setShowFixedBtn(true);
                }
            });
        }
    }, []);
    // TODO: Переписать как ключ значение
    if (category_name === "Люкс") {
        classCategoryReady = "lux";
    } else if (category_name === "Комфорт") {
        classCategoryReady = "comfort";
    } else if (category_name === "Стандарт") {
        classCategoryReady = "standart";
    } else if (category_name === "Эконом") {
        classCategoryReady = "eco";
    }
    var scrollTo = (0,scrollToUtil/* scrollToUtil */.R)(headerHeight);
    var pageRoute = [
        {
            title: "Поиск круизов",
            link: "https://kruiz.online/result"
        },
        {
            title: "Круиз на лайнере ".concat(t_title),
            link: ""
        }, 
    ];
    var ref20 = (0,react.useState)((cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) !== undefined || (cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) === "false"), closeBannersTop = ref20[0], setCloseBannersTop = ref20[1];
    var currentDate = dayjs_min_default()();
    var timeToCookie = currentDate.add(1, "h");
    (0,dist.setCookie)(null, "closeBanner", "false");
    var openBanner = function() {
        setCloseBannersTop(false);
        (0,dist.setCookie)(null, "closeBanner", "false");
    };
    (0,useHiddenWithCookie/* useHiddenWithCookie */._)(openBanner);
    (0,react.useEffect)(function() {
        if (cruiz.actualInfo.type === "inProgress") {
            window.ym(35441960, "reachGoal", "cruise_page_visit_during_trip");
        } else if (cruiz.actualInfo.type === "complete") {
            window.ym(35441960, "reachGoal", "cruise_page_visit_after_trip");
        }
        if (clientBuy) {
            window.ym(35441960, "reachGoal", "cruise_page_visit_by_authenticated_user_for_purchased_cruise");
        }
    }, []);
    var statusCruiseBuy = function() {
        switch(cruiz.actualInfo.type){
            case "inProgress":
                return "Уже в пути";
            case "complete":
                return "Завершен";
            default:
                return "";
        }
    };
    var closeBanners = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStoreProvider/* SearchStoreProvider */.YG, {
        hydrationData: {
            user: user,
            cruiz: cruiz,
            reviews: reviews,
            idCruiz: idCruiz,
            places: places,
            token: token
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStoreProvider/* RootStoreProvider */.LD, {
            hydrationData: {
                user: user,
                cruiz: cruiz,
                reviews: reviews,
                idCruiz: idCruiz,
                places: places,
                token: token
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    title: "Круиз по маршруту ".concat(route_full, " ").concat(startDate, " - ").concat(endDate, " от ").concat(min_price, " рублей"),
                    description: "Забронируйте онлайн морской Круиз по маршруту ".concat(route_full, " с ").concat(startDate, " по ").concat(endDate, " на лайнере ").concat(t_title, " рублей от ").concat(min_price, " рублей."),
                    keywords: "Морской круиз по маршруту ".concat(route_full, " на ").concat(t_title),
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                    lsitMenu: [],
                    isMobile: isMobile,
                    isTablet: isTablet,
                    withoutForm: true,
                    showTopContent: !closeBannersTop,
                    popularPopdirs: popularPopdirs,
                    topContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTop, {
                            isOpen: closeBannersTop,
                            onOpen: setCloseBannersTop,
                            timeToCookie: timeToCookie,
                            isMobile: isMobile,
                            isTablet: isTablet
                        })
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container--block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* BreadCrumbs */.b, {
                                        routeCrumbs: pageRoute
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: isMobile ? {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexDirection: "column"
                                    } : {
                                        display: "flex",
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                maxWidthidth: "920px"
                                            },
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                    component: "h1",
                                                    variant: isMobile ? "heading-4" : "heading-1",
                                                    children: [
                                                        "Круиз на лайнере ",
                                                        t_title,
                                                        " ",
                                                        cruiz.actualInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (cruizPage_module_default()).progressBadge,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                                size: "sm",
                                                                view: cruiz.actualInfo.type,
                                                                children: statusCruiseBuy()
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareSocial/* ModalShareSocial */.p, {
                                            link: currentLink,
                                            isMobile: isMobile
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (cruizPage_module_default()).topBar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cruizPage_module_default()).badgeContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).badgeItemClass,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    view: "text",
                                                    onClick: function() {
                                                        return scrollTo(servicesRef);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: classCategoryReady,
                                                        icon: classCategoryReady,
                                                        size: isMobile ? "sm" : "md",
                                                        children: category_name
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).badgeItem,
                                                children: (0,isBlackFridayCheck/* isNewYear */.m)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    view: "text",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: "newYear",
                                                        icon: "newYear",
                                                        size: isMobile ? "sm" : "md",
                                                        children: "новогодний кешбэк"
                                                    })
                                                })
                                            }),
                                            !!special_note && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).badgeItem,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    view: "text",
                                                    ref: badgeSaleRef,
                                                    onClick: function() {
                                                        badgeSaleRef.current.scrollIntoView({
                                                            behavior: "smooth"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: "season",
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                            name: "promo/badgeSeason",
                                                            width: 18,
                                                            height: 18
                                                        }),
                                                        size: isMobile ? "sm" : "md",
                                                        children: special_note
                                                    })
                                                })
                                            }),
                                            reviews && !!reviews.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).badgeItemClass,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    view: "text",
                                                    onClick: function() {
                                                        return scrollTo(badgeReviewsRef);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: "rewies",
                                                        icon: "\uD83D\uDCAC",
                                                        size: isMobile ? "sm" : "md",
                                                        children: "".concat(reviews.length, "\n              ").concat((0,declOfNum/* declOfNum */.A)(reviews.length, [
                                                            "отзыв",
                                                            "отзыва",
                                                            "отзывов"
                                                        ]))
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).badgeItem,
                                                children: free_places_left < 25 && free_places_left > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    view: "text",
                                                    onClick: function() {
                                                        return scrollTo(elRef);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: "hot",
                                                        icon: "fire",
                                                        size: isMobile ? "sm" : "md",
                                                        children: "Осталось ".concat(free_places_left, "\n              ").concat((0,declOfNum/* declOfNum */.A)(free_places_left, [
                                                            "каюта",
                                                            "каюты",
                                                            "кают"
                                                        ]))
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                mini && maxi && t_title && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGallery/* MainGallery */.k, {
                                    ship_id: ship_id,
                                    reviews: reviews,
                                    maxi: maxi,
                                    mini: mini,
                                    isMobile: isMobile,
                                    category: {
                                        name: category_name,
                                        type: classCategoryReady
                                    },
                                    title: t_title,
                                    isSea: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (cruizPage_module_default()).contentWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (cruizPage_module_default()).mainContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelTime/* TravelTime */.R, {
                                                    size: "lg",
                                                    className: (cruizPage_module_default()).dateBlock,
                                                    start: shortStartDate,
                                                    end: shortEndDate,
                                                    days: kr_days
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (cruizPage_module_default()).route,
                                                            children: [
                                                                return_trip === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                                    children: [
                                                                        route_full,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: (cruizPage_module_default()).returnTrip,
                                                                            children: "(Без возвращения)"
                                                                        })
                                                                    ]
                                                                }) : route_full,
                                                                timetableExcursions.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (cruizPage_module_default()).buttonWrapper,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                        size: "sm",
                                                                        onClick: function() {
                                                                            setCruizeRoutesIsOpen(true);
                                                                        },
                                                                        children: "Открыть маршрут и экскурсии"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        vendor_link && /*#__PURE__*/ (0,jsx_runtime.jsx)(VendorLink/* VendorLink */.h, {
                                                            vendorLink: vendor_link,
                                                            isMobile: isMobile
                                                        })
                                                    ]
                                                }),
                                                isAstoria && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (cruizPage_module_default()).downloadPDFWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                            rightGap: 8,
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                name: "common/download",
                                                                width: 24,
                                                                height: 24
                                                            }),
                                                            title: "Скачать pdf с экскурсионной программой Astoria Grande"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                            href: "https://kruiz.online/files/uploads/AstoriaGrande.pdf",
                                                            variant: "newPromo",
                                                            children: "Экскурсионная программа Astoria Grande.pdf"
                                                        })
                                                    ]
                                                }),
                                                isMobile && (cruiz === null || cruiz === void 0 ? void 0 : (ref2 = cruiz.actualInfo) === null || ref2 === void 0 ? void 0 : ref2.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePanel/* PricePanel */.M, {
                                                    cruizDetail: cruizDetail,
                                                    price: min_price,
                                                    onChoose: function() {
                                                        return scrollTo(elRef);
                                                    },
                                                    priceDiscounted: min_price_discounted || min_price,
                                                    discounts: discounts,
                                                    elRef: badgeClassRef,
                                                    data: favoriteData,
                                                    titleShip: t_title,
                                                    cruiseDateS: kr_date_start,
                                                    cruiseDateE: kr_date_end,
                                                    cruiseDays: kr_days,
                                                    users: user,
                                                    isSea: true,
                                                    disablePickCuteSea: inArray([
                                                        10008,
                                                        100010,
                                                        100020,
                                                        10009,
                                                        100029,
                                                        100028
                                                    ], [
                                                        cruiz.cruise.provider_id
                                                    ]),
                                                    isMobile: isMobile
                                                }),
                                                isMobile && !(cruiz === null || cruiz === void 0 ? void 0 : (ref3 = cruiz.actualInfo) === null || ref3 === void 0 ? void 0 : ref3.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (cruizPage_module_default()).actualPanel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActualPanel/* ActualPanel */.q, {
                                                        actualInfo: cruiz.actualInfo,
                                                        url: url,
                                                        type: cruiz.actualInfo.type
                                                    })
                                                }),
                                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            maxWidth: "390px"
                                                        },
                                                        children: cruiz.cruise.infoblock.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoblockSliders/* InfoblockSliders */.S, {
                                                            type: "info",
                                                            content: cruiz.cruise.infoblock
                                                        })
                                                    })
                                                }),
                                                (price_includes === null || price_includes === void 0 ? void 0 : price_includes.on) && (price_includes === null || price_includes === void 0 ? void 0 : price_includes.off) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* GenericList */.p, {
                                                    title: "Что включено в стоимость",
                                                    items: price_includes.on,
                                                    additional: price_includes.off,
                                                    btn: {
                                                        open: "Показать еще",
                                                        close: "Скрыть услуги"
                                                    }
                                                }),
                                                ((ref4 = cruiz.ship_info) === null || ref4 === void 0 ? void 0 : ref4.booking_conditions) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            component: "h2",
                                                            variant: "heading-4",
                                                            children: "Условия бронирования круиза"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,classcat/* default */.Z)([
                                                                showExcDescription ? [] : [
                                                                    (cruizPage_module_default()).excClipper
                                                                ], 
                                                            ]),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                                                                content: (ref5 = cruiz.ship_info) === null || ref5 === void 0 ? void 0 : ref5.booking_conditions
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (cruizPage_module_default()).buttonClipper,
                                                            children: !showExcDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                onClick: function() {
                                                                    setShowExcDescription(!showExcDescription);
                                                                },
                                                                view: "sm",
                                                                children: "Открыть условия"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                onClick: function() {
                                                                    setShowExcDescription(!showExcDescription);
                                                                },
                                                                view: "sm",
                                                                children: "Скрыть условия"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                placing_children && /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* GenericList */.p, {
                                                    title: "Условия размещения с детьми",
                                                    items: placing_children,
                                                    btn: {
                                                        open: "Все условия",
                                                        close: "Закрыть условия"
                                                    },
                                                    limit: 1
                                                }),
                                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (cruizPage_module_default()).mobileMotivator,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Motivator, {
                                                        emoji: motivatorEmoji,
                                                        textcolor: motivatorColor,
                                                        children: motivatorReady
                                                    })
                                                })
                                            ]
                                        }),
                                        !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                            className: (cruizPage_module_default()).aside,
                                            children: [
                                                (cruiz === null || cruiz === void 0 ? void 0 : (ref6 = cruiz.actualInfo) === null || ref6 === void 0 ? void 0 : ref6.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (cruizPage_module_default()).innerAside,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePanel/* PricePanel */.M, {
                                                        cruizDetail: cruizDetail,
                                                        price: min_price,
                                                        onChoose: function() {
                                                            return scrollTo(elRef);
                                                        },
                                                        priceDiscounted: min_price_discounted || min_price,
                                                        discounts: discounts,
                                                        data: favoriteData,
                                                        titleShip: t_title,
                                                        cruiseDateS: kr_date_start,
                                                        cruiseDateE: kr_date_end,
                                                        cruiseDays: kr_days,
                                                        users: user,
                                                        isSea: true,
                                                        isRequest: true,
                                                        disablePickCuteSea: inArray([
                                                            10008,
                                                            100010,
                                                            100020,
                                                            10009,
                                                            100029,
                                                            100028
                                                        ], [
                                                            cruiz.cruise.provider_id
                                                        ]),
                                                        isMobile: isMobile
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (cruizPage_module_default()).actualPanel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActualPanel/* ActualPanel */.q, {
                                                        actualInfo: cruiz.actualInfo,
                                                        url: url,
                                                        type: cruiz.actualInfo.type
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: ((ref7 = cruiz.cruise) === null || ref7 === void 0 ? void 0 : ref7.infoblock.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoblockSliders/* InfoblockSliders */.S, {
                                                        type: "info",
                                                        content: (ref8 = cruiz.cruise) === null || ref8 === void 0 ? void 0 : ref8.infoblock
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (cruiz === null || cruiz === void 0 ? void 0 : (ref9 = cruiz.actualInfo) === null || ref9 === void 0 ? void 0 : ref9.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: elRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PickCaute/* PickCaute */.u, {
                                isMobile: isMobile,
                                isTablet: isTablet,
                                isSea: true,
                                disablePickCuteSea: inArray([
                                    10008,
                                    100010,
                                    100020,
                                    10009,
                                    100029,
                                    100028
                                ], [
                                    cruiz.cruise.provider_id
                                ]),
                                isSeaCabin: true,
                                items: tariffs,
                                scheme: schema,
                                isAstoria: isAstoria,
                                titleShip: t_title,
                                cruiseDateS: kr_date_start,
                                cruiseDateE: kr_date_end,
                                cruiseDays: kr_days,
                                routeFull: route_full,
                                users: user,
                                idCruiz: idCruiz,
                                minPrice: min_price,
                                closeBanners: closeBanners
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container container--start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (cruiz === null || cruiz === void 0 ? void 0 : (ref10 = cruiz.actualInfo) === null || ref10 === void 0 ? void 0 : ref10.status) ? (cruizPage_module_default()).contentWrapper : (cruizPage_module_default()).contentWrapperNoActual,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (cruizPage_module_default()).mainContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (cruizPage_module_default()).headShips,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                    component: "h2",
                                                                    variant: "heading-4",
                                                                    children: "О Лайнере"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    href: "/ships/".concat(url),
                                                                    rel: "noreferrer",
                                                                    className: (cruizPage_module_default()).headShipsLink,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                            name: "common/blueShip",
                                                                            width: 24,
                                                                            height: 24
                                                                        }),
                                                                        t_title
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CruiseDescription/* CruiseDescription */.X, {
                                                            desc: description,
                                                            url: url,
                                                            shipDetail: shipDetail,
                                                            aboutShip: "лайнеру",
                                                            isMobile: isMobile
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                    className: (cruizPage_module_default()).section,
                                                    ref: servicesRef,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            component: "h2",
                                                            variant: "heading-4",
                                                            children: "Услуги на борту"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* Features */.A, {
                                                            features: facilities
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CancellationAndReturn, {
                                                    policy_details: policy_details,
                                                    cabin_cancellation: cabin_cancellation
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (cruizPage_module_default()).allRiviews,
                                                    ref: badgeReviewsRef,
                                                    children: reviews && !!reviews.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                                className: (cruizPage_module_default()).reviews,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        className: "visually-hidden",
                                                                        children: "Отзывы круизов"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (cruizPage_module_default()).reviewsHeader,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (cruizPage_module_default()).reviewsInfo,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                                    component: "h3",
                                                                                    variant: "heading-6",
                                                                                    children: "Отзывы о круизе"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (cruizPage_module_default()).reviewsCount,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                                        variant: "text-7",
                                                                                        children: reviews.length
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (cruizPage_module_default()).rewiesAction,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                                            href: "http://kruiz.online/reviews",
                                                                            variant: "linkAsbutton2",
                                                                            children: "Написать отзыв"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews/* Reviews */.Z, {
                                                                items: reviews,
                                                                isMobile: isMobile
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                    className: (cruizPage_module_default()).section,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            component: "h2",
                                                            variant: "heading-4",
                                                            children: "Часто задаваемые вопросы"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsed/* Collapsed */.H, {
                                                            items: faqItems,
                                                            shorter: true,
                                                            isCruis: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isMobile && (cruiz === null || cruiz === void 0 ? void 0 : (ref11 = cruiz.actualInfo) === null || ref11 === void 0 ? void 0 : ref11.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                            className: (cruizPage_module_default()).aside,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (cruizPage_module_default()).innerAside,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePanel/* PricePanel */.M, {
                                                    cruizDetail: cruizDetail,
                                                    price: min_price,
                                                    onChoose: function() {
                                                        return scrollTo(elRef);
                                                    },
                                                    priceDiscounted: min_price_discounted || min_price,
                                                    discounts: discounts,
                                                    data: favoriteData,
                                                    titleShip: t_title,
                                                    cruiseDateS: kr_date_start,
                                                    cruiseDateE: kr_date_end,
                                                    cruiseDays: kr_days,
                                                    users: user,
                                                    isSea: true,
                                                    disablePickCuteSea: inArray([
                                                        10008,
                                                        100010,
                                                        100020,
                                                        10009,
                                                        100029,
                                                        100028
                                                    ], [
                                                        cruiz.cruise.provider_id
                                                    ]),
                                                    isMobile: isMobile
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                    condition: isMobile && showFixedBtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (cruizPage_module_default()).fixedBtnWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                size: "semi-lg",
                                                topGap: true,
                                                fullWidth: true,
                                                background: "primary",
                                                onClick: function() {
                                                    return scrollTo(elRef);
                                                },
                                                children: "Выбрать каюту"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                                    fullScreen: true,
                                    size: "sm",
                                    title: "Круиз",
                                    isOpen: cruizeFeaturesIsOpen,
                                    onOpen: setCruizeIsOpen,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (cruizPage_module_default()).modal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "В стоимость входит"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (cruizPage_module_default()).list,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "Проживание на протяжении всего маршрута в каюте выбранного класса — она закрепляется за вами 3-разовое или 2-разовое"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "Питание по ресторанному меню или по системе шведского стола"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "Возможность посещать развлекательные и познавательные программы на борту"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                bottomGap: 16,
                                                component: "p",
                                                children: "Яркие воспоминания о летнем круизе, пожалуй, лучший подарок, который можно сделать себе и близким. Приглашаем отправиться в это увлекательное путешествие: полюбоваться пейзажами русских рек, принять участие в мастер-классах на борту теплохода, узнать много нового во время экскурсий в городах, повеселиться на вечерних шоу-программах и отлично провести время время. Ваш отдых начинается как только Вы заступите на борт судна. Теперь теплоход — ваш плавучий дом отдыха."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "Регистрация"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Для регистрации Вам необходимо предъявить оригинал документа удостоверяющего личность (паспорт, для детей — свидетельство о рождении) и электронную путевку."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Вам необходимо прибыть в Речной порт заранее, чтобы комфортно и без спешки пройти регистрацию на борт, которая обычно начинается за 1,5 - 2 часа до отправления теплохода в круиз."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Во время регистрации, Вы получаете ключ от Вашей каюты (ключ, карточка), номер столика в ресторане, где будет проходить завтрак, обед и ужин, а так же информационные буклеты и ознакомительные листы с программой вашего круиза и распорядка дня."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Заботливые стюарды проводят Вас в вашу каюту и помогут с транспортировкой багажа."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "Заселение"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: 'Обязательно проверьте целостность и рабочее состояние всего оснащения вашей каюты. В зависимости от типа выбранной вами каюты, а также теплохода и его класса, условия могут разниться. В каютах категории выше "Эконом" всегда есть свой санузел с душем. На некоторых судах предлагаются банные наборы, приветственные комплименты, питьевая вода, фен, холодильник, телевизор, кондиционер и т.д. При выборе каюты для отдыха обратите внимание на описание каюты и теплохода, чтобы обеспечить себя всеми условиями для комфортного отдыха.'
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Примерное расписание дня во время путешествия:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: (cruizPage_module_default()).list,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "Подъем в 7 утра, проведение утренней зарядки"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "С 8 до 10 приглашение на завтрак в одну или две смены"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "В час или два по полудню обед"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (cruizPage_module_default()).listItem,
                                                        children: "9-20 часов вечера — ужин"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "О времени проведения всех остальных мероприятий вас будут отдельно уведомлять. В 11 вечера отбой. Парадная и верхняя палубы, бары, дискотека и ресторан закрываются. Хотя, никто не запрещает в каюте заниматься тем, чем вам хочется. Главное — не мешать другим пассажирам. Прогулочная палуба и увеселительные заведения после 23.00 перестают работать. Шуметь запрещено. Курить тоже нельзя, кроме специально отведенных мест."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "Питание"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "В зависимости от теплохода, питание может быть организовано в одну или две смены. Распределение по сменам происходит равномерно по мере бронирования и заполнения круиза, также вы можете выразить пожелание питаться в ту или иную смену, которое мы передадим круизной компании, чаще всего она идет на встречу. Питание может быть организовано по типу шведского стола, накрытия или заказной системе (когда Вы сами выбираете себе меню на следующий день, из предложенных вариантов). Рацион подобран так, чтобы все были сыты, кроме того могут быть и специальные диетические, вегетарианские или облегченные блюда."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Помимо основных ресторанов, на всех теплоходах имеется несколько баров, где можно приобрести алкогольные и безалкогольные напитки, закуски или заказать блюда по меню. Все это не входит стоимость круиза и оплачивается пассажирами самостоятельно."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Если вы хотите взять с собой что-то из продуктов или напитков, убедитесь, что в каюте имеется холодильник. У круизных компаний нет запретов на какую-либо продукцию, которую можно пронести на борт теплохода, основное правило — не употреблять в общественных помещениях и зонах, в своей же каюте вы хозяин."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "Расчет на борту"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "В зависимости от теплохода, на борту может быть только безналичный расчет, только наличный или система бортовых карт, которой вы оплачиваете экскурсии или бар, а после круиза вам выставляют счет с итоговой суммой для оплаты."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                variant: "heading-3",
                                                children: "Высадка на берег, экскурсионная программа"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                component: "p",
                                                children: "Во время большинства стоянок вы сможете отправиться на экскурсию или, если это зеленая стоянка, отдохнуть на пляже, прокатиться на велосипеде, погулять по берегу и купить свежие овощи и фрукты. Во многих городах вы можете выбрать одну из нескольких экскурсий, решив что вам интереснее или приобрести дополнительную."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                                    fullScreen: true,
                                    size: "sm",
                                    title: "Маршрут",
                                    isOpen: cruizeRoutesIsOpen,
                                    onOpen: setCruizeRoutesIsOpen,
                                    actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                                                href: "/api/v1/ApiCruise/GetPdfExcursion/".concat(idCruiz, "/?is_sea=1"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                        name: "common/dow-pdf",
                                                        width: 33,
                                                        height: 32
                                                    }),
                                                    title: "Скачать файл экскурсионную программу в PDF"
                                                })
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (cruizPage_module_default()).modal,
                                        children: timetableExcursions.map(function(i, id) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (cruizPage_module_default()).excursionProgram,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                        variant: "heading-4",
                                                        children: [
                                                            i.route_day,
                                                            " ",
                                                            i.town_name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                        variant: "heading-7",
                                                        color: "returnTrip",
                                                        children: [
                                                            i.day,
                                                            " день"
                                                        ]
                                                    }),
                                                    i.town_name !== "В пути" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (cruizPage_module_default()).schedule,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (cruizPage_module_default()).scheduleItem,
                                                                children: [
                                                                    i.ETS && id !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (cruizPage_module_default()).scheduleDate,
                                                                        children: i.sts_time !== "00:00" && i.sts_time
                                                                    }),
                                                                    i.STS === "0000-00-00" && i.ETS === "0000-00-00" ? i.town_name !== "В пути" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: i.sts_time === "00:00" ? "" : "  Стоянка "
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: i.town_name
                                                                    }) : id !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: i.sts_time === "00:00" ? "" : "  Прибытие"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: i.excursionProgram
                                                                    })
                                                                ]
                                                            }),
                                                            id !== timetableExcursions.length && i.ETS !== "0000-00-00" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (cruizPage_module_default()).scheduleItem,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (cruizPage_module_default()).scheduleDate,
                                                                        children: i.ets_time !== "00:00" && i.ets_time
                                                                    }),
                                                                    id !== timetableExcursions.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: i.town_name !== "В пути" && " Отплытие"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: i.town_name !== "В пути" && " Стоянка"
                                                            }),
                                                            !i.excursions.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcursionGallery/* ExcursionGallery */.E, {
                                                                item: i.town_foto
                                                            })
                                                        ]
                                                    }),
                                                    i.town_name !== "В пути" && !!i.excursions.length && !isAstoria ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsed/* Collapsed */.H, {
                                                        isOpen: true,
                                                        isCruis: true,
                                                        items: [
                                                            {
                                                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (cruizPage_module_default()).scheduleInfoHeader,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                                            width: 30,
                                                                            height: 30,
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                                                name: "common/add-price",
                                                                                width: 24,
                                                                                height: 24
                                                                            }),
                                                                            rightGap: 8,
                                                                            title: "Экскурсионная программа"
                                                                        }),
                                                                        "Экскурсионная программа"
                                                                    ]
                                                                }),
                                                                body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcursionProgramm/* ExcursionProgramm */.t, {
                                                                            data: i
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcursionGallery/* ExcursionGallery */.E, {
                                                                            item: i.town_foto
                                                                        })
                                                                    ]
                                                                })
                                                            }, 
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsed/* Collapsed */.H, {
                                                        isOpen: true,
                                                        isCruis: true,
                                                        items: [
                                                            {
                                                                // title: (
                                                                //   <div className={styles.scheduleInfoHeader}>
                                                                //     <Icon
                                                                //       width={30}
                                                                //       height={30}
                                                                //       icon={
                                                                //         <IconSVG
                                                                //           name={'common/add-price'}
                                                                //           width={24}
                                                                //           height={24}
                                                                //         />
                                                                //       }
                                                                //       rightGap={8}
                                                                //       title="Экскурсионная программа"
                                                                //     />
                                                                //     Экскурсионная программа
                                                                //   </div>
                                                                // ),
                                                                body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcursionProgramm/* ExcursionProgramm */.t, {
                                                                            data: i,
                                                                            isAstoria: isAstoria
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcursionGallery/* ExcursionGallery */.E, {
                                                                            item: i.town_foto
                                                                        })
                                                                    ]
                                                                })
                                                            }, 
                                                        ]
                                                    })
                                                ]
                                            }, id || i);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalReload/* ModalReload */.U, {})
            ]
        })
    });
};


/***/ }),

/***/ 31181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ReworkUrl; }
/* harmony export */ });
// export const ReworkUrl = (url) => typeof url === 'string' && url.startsWith("https://kruiz.online")
//   ? url?.replace("https://kruiz.online", '')
//   : url?.replace("https://sea.z.tech", '');
var ReworkUrl = function(url) {
    if (typeof url !== "string") return null;
    var isProd = url.startsWith("https://kruiz.online");
    if (isProd) return url;
    if (url.startsWith("/")) return "https://kruiz.online".concat(url);
    return url.replace("https://sea.z.tech", "");
};


/***/ }),

/***/ 14971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fc": function() { return /* binding */ formatDateEnd; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "yk": function() { return /* binding */ formatDateStart; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70600);
/* harmony import */ var dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2__);



var formatDateStart = function(dateStart, dateEnd) {
    var dateYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("YYYY"));
    var dateEndYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("YYYY"));
    var start = function(date) {
        if (date !== dateEndYear) {
            return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("DD MMMM YYYY");
        }
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("DD MMMM");
    };
    return start(dateYear);
};
var formatDateEnd = function(dateEnd, isCruise) {
    var thisYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().format("YYYY"));
    var dateYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("YYYY"));
    var start = function(date) {
        if (date !== thisYear) {
            if (isCruise) {
                return "".concat(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM YYYY"), " года");
            }
            return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM YYYY");
        }
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM");
    };
    return start(dateYear);
};
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("ru");
var formatDate = function(dateString) {
    var parsedDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateString, "DD.MM.YYYY");
    if (!parsedDate.isValid()) {
        throw new Error("Неверный формат даты");
    }
    return parsedDate.format("DD MMMM");
};


/***/ }),

/***/ 38264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__Ww9nJ","accordionTitle":"accordion_accordionTitle__M2XG2","innerTitle":"accordion_innerTitle__wJIwd","accordionContent":"accordion_accordionContent__pVsW5","accordionContentActive":"accordion_accordionContentActive__Lnz13","close":"accordion_close__jwAf8","open":"accordion_open__FTLja"};

/***/ }),

/***/ 16886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__Khlbh","avatarImg":"avatar_avatarImg__b7gUj"};

/***/ }),

/***/ 63643:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"comment_wrapper__Vbloe","buttonClipper":"comment_buttonClipper__wGDg6","star":"comment_star__ZqWTb","allInfo":"comment_allInfo__M75JD","excClipper":"comment_excClipper__aeJP2","info":"comment_info__9WxUs","avatar":"comment_avatar__wQRMf","link":"comment_link__A7WfX","user":"comment_user__VyeDY","rating":"comment_rating__1m3wk","img":"comment_img__ei3z0","imgAll":"comment_imgAll__Xl3MV"};

/***/ }),

/***/ 83200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"cancellationandreturn_section__LTQlU","list":"cancellationandreturn_list___vhUk","listItem":"cancellationandreturn_listItem__hNOuI","subdesc":"cancellationandreturn_subdesc__esnr5","ReturnDesc":"cancellationandreturn_ReturnDesc__M4LPv","open":"cancellationandreturn_open__gn2mg"};

/***/ }),

/***/ 55828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dots":"dots_dots__e0bPc","regularDots":"dots_regularDots__1Wi_S","active":"dots_active__dN4oS","longDots":"dots_longDots__Nb5eQ","dynamicWidth":"dots_dynamicWidth__pA3rZ"};

/***/ }),

/***/ 99407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"arrows_btn__MpugV","emblaButton":"arrows_emblaButton__jYhAy","emblaButtonPrev":"arrows_emblaButtonPrev__LLGM1","emblaButtonNext":"arrows_emblaButtonNext__c6yBu","lg":"arrows_lg__q8ytc"};

/***/ }),

/***/ 52851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"image_root__lPXxH","none":"image_none__MXx4v","cover":"image_cover__iOpfP","fill":"image_fill__BMPWp","contain":"image_contain__tYnQv"};

/***/ }),

/***/ 9920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border":"motivator_border__n3SWD","emojiBlock":"motivator_emojiBlock__f8sEz"};

/***/ }),

/***/ 69907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"reviews_infoWrapper__Gz_80","info":"reviews_info__tuce9","button":"reviews_button___jir0"};

/***/ }),

/***/ 36701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Skeleton_card__UKdC1","selectCabin":"Skeleton_selectCabin__aFpe_"};

/***/ }),

/***/ 42517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"traveltime_wrapper__hI5VA","dates":"traveltime_dates__sj_xJ","days":"traveltime_days__aoX9W","time":"traveltime_time__zIMfU","default":"traveltime_default__pzBr4","lg":"traveltime_lg__75snk"};

/***/ }),

/***/ 18201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topBar":"cruizPage_topBar__gsmMM","headShips":"cruizPage_headShips__pO_sI","headShipsLink":"cruizPage_headShipsLink__2EeXr","buttonWrapper":"cruizPage_buttonWrapper__o7MMW","downloadPDFWrapper":"cruizPage_downloadPDFWrapper__hn_X_","bannerCookie":"cruizPage_bannerCookie__0pb2e","actualPanel":"cruizPage_actualPanel__iujJN","innerBanner":"cruizPage_innerBanner__ZaKXc","tourIcon":"cruizPage_tourIcon__LS0VQ","marginBage":"cruizPage_marginBage__01d9R","filterWrapper":"cruizPage_filterWrapper__jLbX_","badgeRight":"cruizPage_badgeRight__rcm1X","searchLink":"cruizPage_searchLink__hvCVG","wrapperBorder":"cruizPage_wrapperBorder__PcXyI","wrapperBorderTour":"cruizPage_wrapperBorderTour__8PtXs","modal":"cruizPage_modal___x3sI","modalFooter":"cruizPage_modalFooter__yFyq4","modalDescription":"cruizPage_modalDescription__rVTnd","modalDuration":"cruizPage_modalDuration__nrTPd","modalDurationInside":"cruizPage_modalDurationInside__yO95T","excursionIncluded":"cruizPage_excursionIncluded__e30SZ","excursionExtra":"cruizPage_excursionExtra__7J7O1","modalMapWrap":"cruizPage_modalMapWrap__OR2XK","progressBadge":"cruizPage_progressBadge__u3gRP","modalMap":"cruizPage_modalMap__KxWOq","wrapperText":"cruizPage_wrapperText__yzpdE","wrapperTextTour":"cruizPage_wrapperTextTour__JUPDh","faq":"cruizPage_faq__kQeas","faqList":"cruizPage_faqList__IGXdQ","contentWrapper":"cruizPage_contentWrapper__gavcV","contentWrapperNoActual":"cruizPage_contentWrapperNoActual__YEHtt","mainContent":"cruizPage_mainContent__CpkI6","aside":"cruizPage_aside__ucvXQ","section":"cruizPage_section__n4p0Z","wrapperSize":"cruizPage_wrapperSize__IhTJK","list":"cruizPage_list___0Pnc","listItem":"cruizPage_listItem__fc1rp","wrapperBorderExc":"cruizPage_wrapperBorderExc__KFpLZ","wrapperTextExc":"cruizPage_wrapperTextExc__KKE2o","additional":"cruizPage_additional__lSzUo","head":"cruizPage_head__8BpM6","offers":"cruizPage_offers__mATPS","dateBlock":"cruizPage_dateBlock__gbqZs","reviews":"cruizPage_reviews__qaAay","reviewsInfo":"cruizPage_reviewsInfo__EmvtE","reviewsCount":"cruizPage_reviewsCount__S_3Lk","shema":"cruizPage_shema__riKvY","shemaText":"cruizPage_shemaText__kIZLI","cards":"cruizPage_cards__8b7ra","cardShips":"cruizPage_cardShips___fba7","route":"cruizPage_route__I5FMR","excClipper":"cruizPage_excClipper__Du6HV","picklPrice":"cruizPage_picklPrice__lpQIK","Garantii":"cruizPage_Garantii__qtv9N","yandexButton":"cruizPage_yandexButton__nP_lB","ServDesc":"cruizPage_ServDesc__ueApz","open":"cruizPage_open___S_C7","badge":"cruizPage_badge__4ENgy","exctext":"cruizPage_exctext__vaT6y","descriptionText":"cruizPage_descriptionText__z_mNA","schedule":"cruizPage_schedule__7Zor_","scheduleItem":"cruizPage_scheduleItem__cA6bd","scheduleDate":"cruizPage_scheduleDate__0QPlF","scheduleInfo":"cruizPage_scheduleInfo__4e_s9","scheduleInfoHeader":"cruizPage_scheduleInfoHeader__37KRR","innerAside":"cruizPage_innerAside__lyUwT","to":"cruizPage_to__Ktj_v","transfer":"cruizPage_transfer__QDCwH","listFull":"cruizPage_listFull__Bns8R","wrapperNoExcursion":"cruizPage_wrapperNoExcursion__1fWBW","townPhoto":"cruizPage_townPhoto__63RZ0","portFoto":"cruizPage_portFoto__pHmoO","imgTown":"cruizPage_imgTown__FMHKt","cancelDesc":"cruizPage_cancelDesc__BHGIH","facilitiesButton":"cruizPage_facilitiesButton__iPj5J","fixedBtnWrapper":"cruizPage_fixedBtnWrapper__jtemt","iconBorder":"cruizPage_iconBorder__sHB6e","mobileMotivator":"cruizPage_mobileMotivator__Pf4IL","returnTrip":"cruizPage_returnTrip__cZm3B","badgeContent":"cruizPage_badgeContent__zpmpH","badgeItem":"cruizPage_badgeItem__gC5_d","AlertWrapper":"cruizPage_AlertWrapper__mxXMk","AlertText":"cruizPage_AlertText__wwEC_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3336,718,3108,889,5082,5190,5395,682,9774,2888,179], function() { return __webpack_exec__(58064); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);